import { LanguageItem } from '../../../common/components/LanguageSelect/LanguageSelect'
import { StatusCheck, StatusCheckItem } from '../../mScripts/tessaScript/types/ScriptNode'
import { RelationRole } from './redux/types'

export const STATUS_CHECK_INTERVAL_MINUTES: number = 5

export const RELATIONS: RelationRole[] = [
  'SUBJECT_OF_CARE',
  'SUBJECT_OF_CARE_PROXY',
  'PERSONAL_HEALTHCARE_PROFESSIONAL',
  'PRIVILEGED_HEALTHCARE_PROFESSIONAL',
  'DIRECTLY_INVOLVED_HEALTHCARE_PROFESSIONAL',
  'INDIRECTLY_INVOLVED_HEALTHCARE_PROFESSIONAL',
  'SUPPORTING_HEALTHCARE_PARTY'
]

export const STATUS_CHECKS: StatusCheckItem[] = [
  { tag: 'hasBeenToToilet', displayValue: 'hasBeenToToilet' },
  { tag: 'isActive', displayValue: 'isActive' },
  { tag: 'isInBedStatus', displayValue: 'isInBedStatus' },
  { tag: 'isOutOfBedStatus', displayValue: 'isOutOfBedStatus' },
  { tag: 'isClientWithinHearingRange', displayValue: 'isClientWithinHearingRange' },
  { tag: 'isClientHome', displayValue: 'isClientHome' },
  { tag: 'hasShownBathroomActivity', displayValue: 'hasShownBathroomActivity' },
  { tag: 'hasClientEaten', displayValue: 'hasClientEaten' }
]

export const LOCATION_TAGS: StatusCheckItem[] = [
  { tag: 'isInBathroom', displayValue: 'In Bathroom' },
  { tag: 'isInKitchen', displayValue: 'In Kitchen' },
  { tag: 'isInPantry', displayValue: 'In Pantry' },
  { tag: 'isInBedroom', displayValue: 'In Bedroom' },
  { tag: 'isInLivingRoom', displayValue: 'In Living Room' },
  { tag: 'isInHall', displayValue: 'In Hall' },
  { tag: 'isInToilet', displayValue: 'In Toilet' },
  { tag: 'isInDiningRoom', displayValue: 'In Dining Room' },
  { tag: 'isInOffice', displayValue: 'In Office' },
  { tag: 'isInHobbyRoom', displayValue: 'In Hobby Room' },
  { tag: 'isInGuestRoom', displayValue: 'In Guest Room' },
  { tag: 'isInEntrance', displayValue: 'In Entrance' },
  { tag: 'isInStairs', displayValue: 'On Stairs' },
  { tag: 'isInCorridor', displayValue: 'In Corridor' },
  { tag: 'isInOther', displayValue: 'In Other Area' },
  { tag: 'isInLaundryRoom', displayValue: 'In Laundry Room' },
  { tag: 'isInStorageRoom', displayValue: 'In Storage Room' },
  { tag: 'isInGarage', displayValue: 'In Garage' },
  { tag: 'isInGarden', displayValue: 'In Garden' },
  { tag: 'isInTerrace', displayValue: 'On Terrace' },
  { tag: 'isInBalcony', displayValue: 'On Balcony' },
  { tag: 'isInCommunalArea', displayValue: 'In Communal Area' }
]



export const STATUSES = ["pass", "fail"]

export const ROBOT_LANGUAGES = (capabilities?: string[]): LanguageItem[] => {
  const languages = [
    { tag: 'nl-NL', displayValue: 'Nederlands - Dutch (nl-NL)' },
    { tag: 'en-GB', displayValue: 'English (en-GB)' },
    { tag: 'de-DE', displayValue: 'Deutsch - German (de-DE)' },
    { tag: 'it-IT', displayValue: 'Italiano - Italian (it-IT)' },
    { tag: 'zh-TW', displayValue: '中文 - Chinese (zh-TW)' }
  ]
  if (capabilities?.includes('languageTurkish-v1')) {
    languages.push({ tag: 'tr-TR', displayValue: 'Türkçe - Turkish (tr-TR) (Beta)' })
  }
  return languages
}

export const ROBOT_LANGUAGES_SHORT = (capabilities?: string[]): LanguageItem[] => {
  const languages = [
    { tag: 'nl-NL', displayValue: 'Nederlands - Dutch (nl-NL)', selectValue: 'NL' },
    { tag: 'en-GB', displayValue: 'English (en-GB)', selectValue: 'EN' },
    { tag: 'de-DE', displayValue: 'Deutsch - German (de-DE)', selectValue: 'DE' },
    { tag: 'it-IT', displayValue: 'Italiano - Italian (it-IT)', selectValue: 'IT' },
    { tag: 'zh-TW', displayValue: '中文 - Chinese (zh-TW)', selectValue: '中文' }
  ]
  if (capabilities?.includes('languageTurkish-v1')) {
    languages.push({ tag: 'tr-TR', displayValue: 'Türkçe - Turkish (tr-TR) (Beta)', selectValue: 'TR' })
  }
  return languages
}
